import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import { Checkbox } from 'antd';
import style from './UnassignedCheckbox.module.scss';

export const UnassignedCheckbox: React.FC = () => {
	const { changeIsUnassignedDishesStatus, isUnassignedDishes } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	return (
		<Checkbox
			className={style.checkbox}
			onChange={(e) => changeIsUnassignedDishesStatus(e.target.checked)}
			checked={isUnassignedDishes}
			data-test="UnassignedCheckbox">
			<Text translationNameSpace="listing" translationKey="unassignedDishesLabel" asFragment={true} />
		</Checkbox>
	);
};
